import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import {
  FlexRow,
  FlexColCenter,
  FlexRowCenter,
  FlexCol,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP } from '../../Defaults/Text';
import { IconImg } from '../../Defaults/Icon/IconImg';
import * as infoGreenSrc from '../../../../assets/zemplin/info-green.svg';
import * as infoRedSrc from '../../../../assets/zemplin/info-red.svg';

interface Props {
  onStock: number;
  unit: string;
  bottomMargin?: boolean;
}

function StockInfo({ onStock, unit, bottomMargin = true }: Props) {
  const stockText =
    onStock > 0 ? `${__('Skladom')} ${onStock} ${unit}` : __('Na dopyt');
  const isAvailable = onStock > 0;

  return (
    <StockCount bottomMargin={bottomMargin} available={isAvailable}>
      {stockText}{' '}
      {/*<IconImg
        width={20}
        height={20}
        marginLeft={10}
        alt="info-icon"
        src={isAvailable ? infoGreenSrc.toString() : infoRedSrc.toString()}
      />{' '}*/}
    </StockCount>
  );
}

const StockCount = styled.span<{ available: boolean; bottomMargin: boolean }>`
  display: flex;
  align-items: center;
  font-size: ${rem(12)};
  color: ${({ theme, available }) =>
    available
      ? theme.colors.stockCountAvailable
      : theme.colors.stockCountUnavailable};
  font-family: ${({ theme }) => theme.font.primary};
  line-height: ${rem(22)};
  width: 100%;
  text-align: left;
`;

export { StockInfo };
